// extracted by mini-css-extract-plugin
export default {"header-container":"Product_header-container__oZ-6r","flex":"Product_flex__3Y1Q5"};